import React from "react";
import { AccordionItemType } from "../../../common/types/common";

export function FaqItem({ item }: { item: AccordionItemType }) {
	let link: React.ReactNode;
	const linkUrl = item.linkUrl;
	const description = item.content;

	if (linkUrl) {
		link = (
			<a href={item.linkUrl} className="btn btn--secondary">
				Learn more
			</a>
		);
	}

	const content =
		typeof description === "string" ? <p>{description}</p> : description;

	return (
		<div className="typography">
			{content}
			{link}
		</div>
	);
}
